import React, { useMemo } from 'react';
import type { IconName, IconProps } from '@goodfynd/ui';
import { Icon, Text } from '@goodfynd/ui';
import { stringUtil } from '@goodfynd/utils';

import config from '../../../config';
import strings from '../../../config/strings';
import VendorImages from '../../../hooks/useVendorSearch/VendorImages';

import {
  StyledCardContainer,
  StyledCardContent,
  StyledLink,
  StyledQuickInfo,
} from './styles';
import type { VendorCardProps } from './types';

export default function EventVendorCard({ data }: VendorCardProps) {
  const vendorUrl = stringUtil.replace(config.routes.vendors.details, {
    ':id': data.vendorNameId || data.vendorId,
  });

  const icon = useMemo<IconName | undefined>(() => {
    switch (data.status) {
      case 'canceled':
        return 'cancel';

      case 'confirmed':
        return 'star_filled';

      case 'registered':
      case 'rejected':
      case 'selected':
        return;
    }
  }, [data.status]);

  const iconColor = useMemo<IconProps['color'] | undefined>(() => {
    switch (data.status) {
      case 'canceled':
        return 'TextIconDanger';

      case 'confirmed':
        return 'ComponentTagTextOrange';

      case 'registered':
      case 'rejected':
      case 'selected':
        return;
    }
  }, [data.status]);

  const status = useMemo(() => {
    switch (data.status) {
      case 'canceled':
        return strings.labels.canceled;

      case 'confirmed':
        return strings.labels.confirmed;

      case 'registered':
      case 'rejected':
      case 'selected':
        return;
    }
  }, [data.status]);

  return (
    <StyledLink href={vendorUrl}>
      <StyledCardContainer>
        <VendorImages image={data.vendorImage} />

        <StyledCardContent>
          <Text as="subhead2">{data.vendorName}</Text>

          <StyledQuickInfo>
            <Icon color={iconColor} name={icon} size={18} />
            <Text as="body2">&nbsp;{status}</Text>
          </StyledQuickInfo>
        </StyledCardContent>
      </StyledCardContainer>
    </StyledLink>
  );
}
